export const UI_SIDEBAR_ITEMS_STORE = "ui_sidebar_items";
export const UI_COMPONENTS_STORE = "ui_components";
export const UI_COMPONENT_SPECS_STORE = "ui_component_specs";

const UI_DATABASE_NAME = "exordos-ecosystem-ui";
const UI_DATABASE_VERSION = 7;

let uiDatabasePromise: Promise<IDBDatabase> | null = null;

export function getUiDatabase(): Promise<IDBDatabase> {
  if (!uiDatabasePromise) {
    uiDatabasePromise = openUiDatabase();
  }

  return uiDatabasePromise;
}

export function requestToPromise<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    request.addEventListener("success", () => resolve(request.result));
    request.addEventListener("error", () => {
      reject(request.error ?? new Error("IndexedDB request failed."));
    });
  });
}

export function transactionDone(transaction: IDBTransaction): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    transaction.addEventListener("complete", () => resolve());
    transaction.addEventListener("abort", () => {
      reject(transaction.error ?? new Error("IndexedDB transaction aborted."));
    });
    transaction.addEventListener("error", () => {
      reject(transaction.error ?? new Error("IndexedDB transaction failed."));
    });
  });
}

function openUiDatabase(): Promise<IDBDatabase> {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(UI_DATABASE_NAME, UI_DATABASE_VERSION);

    request.addEventListener("upgradeneeded", (event) => {
      upgradeUiDatabase(request.result, event.oldVersion);
    });

    request.addEventListener("success", () => resolve(request.result));
    request.addEventListener("error", () => {
      uiDatabasePromise = null;
      reject(request.error ?? new Error("Unable to open UI IndexedDB."));
    });
  });
}

function upgradeUiDatabase(database: IDBDatabase, oldVersion: number): void {
  if (oldVersion < 4) {
    if (database.objectStoreNames.contains("ui_panels")) {
      database.deleteObjectStore("ui_panels");
    }

    if (database.objectStoreNames.contains(UI_SIDEBAR_ITEMS_STORE)) {
      database.deleteObjectStore(UI_SIDEBAR_ITEMS_STORE);
    }

    if (database.objectStoreNames.contains(UI_COMPONENTS_STORE)) {
      database.deleteObjectStore(UI_COMPONENTS_STORE);
    }
  }

  if (!database.objectStoreNames.contains(UI_SIDEBAR_ITEMS_STORE)) {
    const store = database.createObjectStore(UI_SIDEBAR_ITEMS_STORE, {
      keyPath: "storageKey",
    });

    store.createIndex("by_scope", "scopeKey", { unique: false });
  }

  if (!database.objectStoreNames.contains(UI_COMPONENTS_STORE)) {
    const store = database.createObjectStore(UI_COMPONENTS_STORE, {
      keyPath: "storageKey",
    });

    store.createIndex("by_scope", "scopeKey", { unique: false });
  }

  if (!database.objectStoreNames.contains(UI_COMPONENT_SPECS_STORE)) {
    const store = database.createObjectStore(UI_COMPONENT_SPECS_STORE, {
      keyPath: "storageKey",
    });

    store.createIndex("by_scope", "scopeKey", { unique: false });
  }

  if (oldVersion < 6) {
    if (database.objectStoreNames.contains("ui_data_sources")) {
      database.deleteObjectStore("ui_data_sources");
    }

    if (database.objectStoreNames.contains("shared_data_providers")) {
      database.deleteObjectStore("shared_data_providers");
    }
  }
}
